// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"aaf34f97","374":"d94a7e79","401":"3bbab213","763":"9b6183d0","788":"f2625c1a"}[chunkId] + ".chunk.css";
};